import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { reCaptchaStyles as styles } from "@insite/content-library/Components/ReCaptcha";
import { css } from "styled-components";

styles.errorMessageText = {
    ...styles.errorMessageText,
    weight: 400,
    color: colorStrings.dangerMain,
    css: css`
        font-size: 10px;
        line-height: 14px;
        margin-top: 5px;

        ${mediaQueriesBP.minMD} {
            font-size: 12px;
            line-height: 16px;
            margin-top: 10px;
        }
    `,
};
